import React from 'react';
import './VariousGovtOfficialsNOCs.css'; // Create a CSS file for specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundim from '../../assets/images/govt-off-1.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_govt_nocs_banner from '../../assets/images/govt-off-1.jpg'; // Replace with an appropriate image path
import { FaUserTie, FaGavel, FaShieldAlt, FaCogs, FaFileAlt, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function VariousGovtOfficialsNOCs() {
  const benefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Compliance Assurance',
      text: 'Ensure compliance with various government regulations efficiently.',
    },
    {
      icon: <FaUserTie />,
      title: 'Simplified Coordination',
      text: 'Streamline coordination with multiple government officials.',
    },
    {
      icon: <FaGavel />,
      title: 'Legal Assurance',
      text: 'Avoid legal hurdles with proper documentation and approvals.',
    },
    {
      icon: <FaCogs />,
      title: 'Time-Saving Process',
      text: 'Reduce the time spent navigating complex NOC processes.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Discuss your specific NOC requirements with our experts.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Document Compilation',
      description: 'Prepare and gather the required documents for submission.',
    },
    {
      icon: <FaUserTie />,
      title: 'Liaison with Officials',
      description: 'Coordinate with government officials to ensure smooth processing.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit NOC applications and follow up for updates.',
    },
    {
      icon: <FaCertificate />,
      title: 'NOC Approval',
      description: 'Receive the approved NOCs for your project or business.',
    },
  ];

  const acts = [
    'Environmental Protection Act, 1986',
    'Water (Prevention and Control of Pollution) Act, 1974',
    'Air (Prevention and Control of Pollution) Act, 1981',
    'State-Specific Guidelines for NOCs',
  ];

  const explanation =
    'Various government NOCs ensure compliance with sector-specific regulations and help businesses operate legally and ethically under prescribed guidelines.';

  const checklistItems = [
    { name: 'Application Form', description: 'Complete the application form for the required NOC.' },
    { name: 'Identity Proof', description: 'Submit valid identity proof of the applicant.' },
    { name: 'Project Details', description: 'Provide detailed information about the project or business.' },
    { name: 'Supporting Documents', description: 'Attach all necessary supporting documents as per requirements.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Various Government Officials NOCs"
        subheading="Get assistance with obtaining necessary NOCs for smooth operations."
        ctaPrimary={{ text: 'Request Assistance', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/various-govt-officials-nocs' }}
        backgroundImage={backgroundim} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What are Government NOCs?"
        description="Government NOCs (No Objection Certificates) are essential for ensuring compliance with regulations and guidelines set by various authorities. We help you navigate the process seamlessly."
        image={img_govt_nocs_banner} // Replace with an image relevant to NOCs
        altText="Government NOCs Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Government NOCs"
        description="Explore the importance of obtaining NOCs and how they benefit your operations."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Regulations and Guidelines"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Process for Government NOCs"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Government NOCs Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
